import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import RichText from 'components/RichText'
import { IS_BRAND_PULSZBINGO } from 'config/brands'
import content from 'prismic-translates/common.json'
import pulszSeoHome from 'prismic-translates/pulsz-seo-home.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content, pulszSeoHome])

export default function SeoContent() {
  return (
    <div className={classes.root} data-test='home-footer-seo-text'>
      {IS_BRAND_PULSZBINGO ? (
        <>
          <h1>{t('pulszbingo_seo_title')}</h1>
          <p>{t('pulszbingo_seo_text1')}</p>
          <p>{t('pulszbingo_seo_text2')}</p>
        </>
      ) : (
        <>
          <h1>{t('main_title')}</h1>
          <RichText field={t('main_title_content')} />

          <h2>{t('title_why')}</h2>
          <RichText field={t('title_why_content')} />

          <h3>{t('title_massive')}</h3>
          <RichText field={t('title_massive_content')} />

          <h3>{t('title_providers')}</h3>
          <RichText field={t('title_providers_content')} />

          <h3>{t('title_free')}</h3>
          <RichText field={t('title_free_content')} />

          <h3>{t('title_games')}</h3>
          <RichText field={t('title_games_content')} />

          <h3>{t('title_exclusive')}</h3>
          <RichText field={t('title_exclusive_content')} />

          <h2>{t('title_all')}</h2>
          <p>{t('title_all_content')}</p>

          <h3>{t('title_slot')}</h3>
          <RichText field={t('title_slot_content')} />

          <h3>{t('title_arcade')}</h3>
          <RichText field={t('title_arcade_content')} />

          <h3>{t('title_table')}</h3>
          <RichText field={t('title_table_content')} />

          <h2>{t('title_play')}</h2>
          <RichText field={t('title_play_content')} />
        </>
      )}
    </div>
  )
}
